// removed by extract-text-webpack-plugin
module.exports = {"tooltipContainer":"Callout__tooltipContainer__9eac8c9d","title":"Callout__title__9eac8c9d","triangle":"Callout__triangle__9eac8c9d","close":"Callout__close__9eac8c9d","closeButton":"Callout__closeButton__9eac8c9d","divider":"Callout__divider__9eac8c9d","text":"Callout__text__9eac8c9d"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/Callout/Callout.scss
// module id = 374
// module chunks = 4 5 6 7 8 14 23 25